import React, { useState } from 'react';
import '../../styles/components/forms.css';

const PasswordField = ({ id, placeholder, value, onChange, required = false }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-group password-input">
      <input
        type={showPassword ? "text" : "password"}
        className="form-control"
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={togglePasswordVisibility}
      >
        <i className={`fas fa-${showPassword ? 'eye' : 'eye-slash'}`}></i>
      </button>
    </div>
  );
};

export default PasswordField;